import { Box } from '@mui/material';
import useWidth from '../../../../components/Hooks/useWidth';
import Highlights from '../../../../modules/highlights/Highlights';
import RachelInput from '../../../../modules/rachel/components/RachelInput/RachelInput';
import { useIsRachelFooterInputVisible } from '../../../../modules/rachel/hooks/useIsRachelFooterInputVisible';
import { getRachelDockedColumnWidth } from '../../../../modules/rachel/rachel.layout';
import UserMenuTrigger from '../UserMenu/UserMenuTrigger';

const HomeNavigationBottomBar = () => {
  const isRachelInputVisible = useIsRachelFooterInputVisible();
  const { mobileWidth: isMobile } = useWidth();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
      }}
    >
      {!isMobile && <UserMenuTrigger />}
      <Highlights />
      {isRachelInputVisible && (
        <Box
          sx={(theme) => ({
            position: 'relative',
            zIndex: theme.zIndex.drawer,
            width: getRachelDockedColumnWidth(theme),
            maxWidth: '100%',
            transform: 'translateY(1px)',
          })}
        >
          <RachelInput />
        </Box>
      )}
    </Box>
  );
};

export default HomeNavigationBottomBar;
